import styled from "styled-components";


export const Wrapper = styled.div`
.lead-status-container {
    /* background-color: red; */
    border: 1px solid lightgray;
    border-radius: 8px;
  }

  .lead-form-row {
    padding: 20px 0px 0px 20px;
  }
  .label-conatiner {
    font-size: 15px;
    font-weight: bold;
  }
  .text-conatiner {
    font-size: 15px;
  }

  .status-rescheduled-container {
    border: 1px solid lightgray;
    border-radius: 8px;
  }
  .status-rescheduled-row {
    padding: 20px;
  }
  .rescheduled-row {
    display: flex;
    flex-direction: column;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 40px;
  }
  .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
  .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
    margin-top: 5px;
  }
  .admin-button-col {
    margin-top: 20px;
    /* padding-bottom: 67px; */
  }
  .button-edit {
    cursor: pointer;
    margin-left: 10px;
    // margin-top: -7px;
    // background-color: #fff;
    // svg {
    //   fill: black;
    // }
  }
  .edit-cross-tick {
    display: flex;
    /* background-color: red; */
    align-items: center;
    justify-content: space-between;
    svg {
      background-color: #3a96b8;
      border-radius: 20px;
      font-size: 22px;
      fill: #fff;
    }

    .deKOJF {
      background-color: #fff;
      display: flex;
      align-items: center;
      height: 23px;
      padding: 0px;
      width: 23px;
    }
  }
  .utility-bill {
    text-decoration: underline;
  }









`